import { SET_DATA, SET_LOADING } from './regions.mutations';
import api from '../../shared/services/api';

export const FETCH_DATA = 'fetchData';

const fetchData = async ({ commit }, dataSourceId) => {
  const { data } = await api.get(`datasources/${dataSourceId}/records?orient=records&page_size=100000`, {
    camelize: false,
  });

  commit(SET_DATA, data.results);
  commit(SET_LOADING, false);
};

export default {
  [FETCH_DATA]: fetchData,
};
